class ModernTestimonialSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.testimonial-track');
    this.slides = Array.from(el.querySelectorAll('.testimonial-item'));
    this.nextBtn = el.querySelector('.slider-nav--next');
    this.dots = Array.from(el.querySelectorAll('.dot'));
    this.currentIndex = 0;
    this.isTransitioning = false;

    if (!this.track || !this.slides.length || !this.nextBtn) {
      console.error('Required slider elements not found');
      return;
    }

    this.init();
  }

  init() {
    this.updateVisibleSlides();
    this.updateDots();

    // Next button → move forward and loop
    this.nextBtn.addEventListener('click', () => this.moveToNext());

    // Dots → only move forward or jump to selected (loop supported)
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.moveToSlide(index));
    });

    // Window resize handler
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.updateVisibleSlides();
        this.updateSlidePosition(false);
      }, 250);
    });

    // Swipe / drag support
    this.initForwardSwipeSupport();
  }

  updateVisibleSlides() {
    const width = window.innerWidth;
    if (width <= 768) {
      this.visibleSlides = 1;
    } else if (width <= 1024) {
      this.visibleSlides = 2;
    } else {
      this.visibleSlides = 3;
    }
  }

  getMaxIndex() {
    return Math.max(0, this.slides.length - this.visibleSlides);
  }

  moveToNext() {
    if (this.isTransitioning) return;

    this.currentIndex++;

    // ✅ Loop back to start when reaching the end
    if (this.currentIndex > this.getMaxIndex()) {
      this.currentIndex = 0;
    }

    this.updateSlidePosition(true);
    this.updateDots();
  }

  moveToSlide(index) {
    if (this.isTransitioning) return;

    // ✅ Ensure looping behavior
    if (index > this.getMaxIndex()) {
      this.currentIndex = 0;
    } else if (index < 0) {
      this.currentIndex = this.getMaxIndex();
    } else {
      this.currentIndex = index;
    }

    this.updateSlidePosition(true);
    this.updateDots();
  }

  updateSlidePosition(animate = true) {
    if (!this.slides.length) return;

    this.isTransitioning = true;
    const slideWidth = this.slides[0].offsetWidth;
    const gap = 24;
    const totalWidth = slideWidth + gap;
    const transform = -(this.currentIndex * totalWidth);

    this.track.style.transition = animate
      ? 'transform 0.5s ease-in-out'
      : 'none';

    this.track.style.transform = `translateX(${transform}px)`;

    setTimeout(() => {
      this.isTransitioning = false;
    }, 500);
  }

  updateDots() {
    if (!this.dots.length) return;
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }

  // ✅ Swipe & drag only move forward — loops supported
  initForwardSwipeSupport() {
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    // Touch events
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    }, { passive: true });

    this.track.addEventListener('touchend', () => {
      if (!isDragging) return;
      const diffX = currentX - startX;
      if (diffX < -50) this.moveToNext();
      isDragging = false;
    });

    // Mouse drag
    let mouseStartX = 0;
    let mouseCurrentX = 0;
    this.track.addEventListener('mousedown', (e) => {
      mouseStartX = e.clientX;
      isDragging = true;
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      mouseCurrentX = e.clientX;
    });

    document.addEventListener('mouseup', () => {
      if (!isDragging) return;
      const diffX = mouseCurrentX - mouseStartX;
      if (diffX < -50) this.moveToNext();
      isDragging = false;
    });
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.modern-testimonial-slider').forEach(slider => {
    new ModernTestimonialSlider(slider);
  });
});
